import { Link2, Youtube, FileText, StickyNote, PlayCircle, Image as ImageIcon } from 'lucide-react';

/** Icon, icon color class and i18n label key for a doc's source_type. */
export const sourceMeta = (type) => {
  switch (type) {
    case 'youtube':
      return { Icon: Youtube, color: 'text-keep-ytRed', labelKey: 'source.youtube' };
    case 'tiktok':
      return { Icon: PlayCircle, color: 'text-keep-text', labelKey: 'source.tiktok' };
    case 'instagram':
      return { Icon: PlayCircle, color: 'text-keep-urlBlue', labelKey: 'source.instagram' };
    case 'url':
      return { Icon: Link2, color: 'text-keep-urlBlue', labelKey: 'source.link' };
    case 'pdf':
      return { Icon: FileText, color: 'text-keep-pdfGreen', labelKey: 'source.pdf' };
    case 'image':
      return { Icon: ImageIcon, color: 'text-keep-imagePurple', labelKey: 'source.image' };
    default:
      return { Icon: StickyNote, color: 'text-keep-noteOrange', labelKey: 'source.note' };
  }
};
